"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _react = _interopRequireWildcard(require("react"));
var _box = require("@oneloop/box");
var _theme = _interopRequireDefault(require("@oneloop/theme"));
var _excluded = ["children"],
  _excluded2 = ["children"],
  _excluded3 = ["children", "row"],
  _excluded4 = ["children", "disabled", "variant", "selected", "id"],
  _excluded5 = ["children", "center", "id", "variant"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TableContext = /*#__PURE__*/(0, _react.createContext)();
var Table = exports.Table = function Table(props) {
  var ref = _react["default"].useRef();
  var _useState = (0, _react.useState)(''),
    _useState2 = _slicedToArray(_useState, 2),
    idHover = _useState2[0],
    setIdHover = _useState2[1];
  var value = _react["default"].useMemo(function () {
    return {
      idHover: idHover,
      setIdHover: setIdHover,
      ref: ref
    };
  }, [idHover]);
  return /*#__PURE__*/_react["default"].createElement(TableContext.Provider, {
    value: value
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "table"
  }, props, {
    __css: {
      fontFamily: 'primary',
      width: '100%',
      borderSpacing: '0px 4px'
    }
  })));
};
var useTableContext = function useTableContext() {
  var context = (0, _react.useContext)(TableContext);
  if (!context) {
    throw new Error('Table compound components cannot be rendered outside the Dropdown component');
  }
  return context;
};
var TableHeaderItem = function TableHeaderItem(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "th"
  }, props, {
    __css: {
      py: '16px',
      color: 'white',
      mb: '5px',
      backgroundColor: 'secondary'
      // ':firstchild': {
      //   borderRadius: 'input',
      // },
    }
  }));
};
var TableBody = function TableBody(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "tbody"
  }, props));
};
var TableHeader = function TableHeader(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "thead"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "tr"
  }, props), children));
};
var TableRow = function TableRow(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "tr"
  }, props));
};
var TableRowItem = function TableRowItem(props) {
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "td"
  }, props, {
    __css: {
      py: '16px',
      color: 'darkGrey',
      mb: '5px',
      backgroundColor: 'inputBackground'
      // ':firstchild': {
      //   borderRadius: 'input',
      // },
    }
  }));
};
var TableHeaderDefault = function TableHeaderDefault(_ref2) {
  var children = _ref2.children,
    props = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, {
    as: "thead"
  }, /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "tr"
  }, props, {
    __css: {
      fontFamily: 'Nunito Sans',
      padding: '12px 16px 12px 16px',
      gap: '8px',
      backgroundColor: 'neutralGray2',
      borderRadius: '8px',
      display: 'table-row',
      flexDirection: 'row',
      alignItems: 'center',
      mb: '8px',
      height: '60px'
    }
  }), children));
};
var TableHeaderItemDefault = function TableHeaderItemDefault(_ref3) {
  var children = _ref3.children,
    row = _ref3.row,
    props = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "th"
  }, props, {
    __css: _objectSpread({
      color: 'white',
      py: '19px',
      backgroundColor: 'neutralGray2',
      '&:first-child': {
        paddingLeft: '24px',
        borderBottomLeftRadius: '8px',
        borderTopLeftRadius: '8px'
      },
      '&:last-child': {
        paddingRight: '24px',
        borderBottomRightRadius: '8px',
        borderTopRightRadius: '8px'
      }
    }, props.__css)
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      display: 'flex',
      flexDirection: row ? 'row' : 'column',
      justifyContent: 'flex-start',
      alignItems: row ? 'center' : 'flex-start',
      gap: row ? '2px' : '0px'
    }
  }, children));
};
var TableRowDefault = function TableRowDefault(_ref4) {
  var children = _ref4.children,
    disabled = _ref4.disabled,
    _ref4$variant = _ref4.variant,
    variant = _ref4$variant === void 0 ? 'primary' : _ref4$variant,
    selected = _ref4.selected,
    _ref4$id = _ref4.id,
    id = _ref4$id === void 0 ? 0 : _ref4$id,
    props = _objectWithoutProperties(_ref4, _excluded4);
  if (disabled) {
    variant = variant + 'Disabled';
  }
  var _useTableContext = useTableContext(),
    setIdHover = _useTableContext.setIdHover;
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "tr",
    tx: "rows",
    variant: selected && !disabled ? variant + 'Selected' : variant,
    onMouseOver: function onMouseOver() {
      return !disabled && setIdHover(id);
    },
    onMouseOut: function onMouseOut() {
      return !disabled && setIdHover(undefined);
    }
  }, props, {
    __css: {
      fontFamily: 'Nunito Sans',
      padding: '6px 12px 6px 12px',
      gap: '12px',
      backgroundColor: '#FFFFFF',
      borderRadius: '8px',
      height: variant === 'minimalist' ? '47px' : '60px',
      mb: '8px',
      color: disabled ? 'neutralGray4' : 'neutralGray2',
      paddingBottom: '1em'
    }
  }), children);
};
var TableRowItemDefault = function TableRowItemDefault(_ref5) {
  var children = _ref5.children,
    center = _ref5.center,
    _ref5$id = _ref5.id,
    id = _ref5$id === void 0 ? 0 : _ref5$id,
    _ref5$variant = _ref5.variant,
    variant = _ref5$variant === void 0 ? 'primary' : _ref5$variant,
    props = _objectWithoutProperties(_ref5, _excluded5);
  var _useTableContext2 = useTableContext(),
    idHover = _useTableContext2.idHover;
  var variantValues = Object.values(_theme["default"].rows)[Object.keys(_theme["default"].rows).indexOf(variant || 'primary')];
  var border = idHover !== id ? variantValues.border || '1px solid #00000000' : variantValues.borderHover;
  return /*#__PURE__*/_react["default"].createElement(_box.Box, _extends({
    as: "td"
  }, props, {
    __css: {
      gap: '1px',
      borderTop: border,
      borderBottom: border,
      '&:first-child': {
        paddingLeft: '24px',
        borderBottomLeftRadius: '8px',
        borderTopLeftRadius: '8px',
        borderLeft: border
      },
      '&:last-child': {
        paddingRight: '24px',
        borderBottomRightRadius: '8px',
        borderTopRightRadius: '8px',
        borderRight: border
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_box.Box, {
    __css: {
      gap: '2px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: center ? 'center' : 'flex-start',
      alignItems: center ? 'center' : 'flex-start'
    }
  }, children));
};
Table.Header = TableHeader;
Table.HeaderItem = TableHeaderItem;
Table.Rows = TableBody;
Table.Row = TableRow;
Table.RowItem = TableRowItem;
Table.HeaderDefault = TableHeaderDefault;
Table.HeaderItemDefault = TableHeaderItemDefault;
Table.RowDefault = TableRowDefault;
Table.RowItemDefault = TableRowItemDefault;